// tslint:disable-next-line: no-any
export const splitItemsToColumns = (columnsCount: number) => (items: any[]) => {
  const itemsPerColumn = Math.ceil(items.length / columnsCount);

  return new Array(columnsCount)
    .fill(null)
    .map((_, index) => items.slice(index * itemsPerColumn, (index + 1) * itemsPerColumn));
};
